import { Button, Flex, Heading, useDisclosure, VStack } from "@chakra-ui/react";
import React, { useContext, useEffect, useState } from "react";
import { fetchController } from "../../../utils/FetchController/fetchController";
import Loader from "../../../utils/Loader/Loader";
import PaginationSizeSelect from "../../../utils/Loader/PaginationSizeSelect";
import Paginator from "../../../utils/Loader/Paginator";
import { getHostDomain } from "../../../utils/utils";
import AddPromptModal from "../../Modals/AddPrompt";
import Table from "../../Tables/Table";
import { AgencyContext } from "../../Settings/AgencyProvider/AgencyProvider";

const Prompt = () => {
  const baseUrl = getHostDomain();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const agency = useContext(AgencyContext);
  const { textColor, buttonColorScheme } = agency;

  const [heads, setHeads] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [status, setStatus] = useState("idle");
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(0);
  const [paginationSize, setPaginationSize] = useState(50);

  const getPrompts = async () => {
    try {
      setStatus("loading");
      const response = await fetchController(
        baseUrl + `/api/v1/prompt/list?size=${paginationSize}&page=${page}`,
        "GET"
      );
      setPages(response?.data?.pages);

      const headsData = ["name", "description"];
      const columns = headsData.map((key) => ({
        Header: key,
        accessor: key,
        Filter: ({ column }) => <input {...column.filterProps} />,
      }));
      setTableData(response.data.items);
      setHeads(columns);
    } catch (error) {
      console.error(error);
    } finally {
      setStatus("idle");
    }
  };

  useEffect(() => {
    getPrompts();
  }, [paginationSize]);

  return (
    <VStack
      h="100%"
      spacing={2}
      justifyContent={"space-between"}
      borderRadius="md"
    >
      <Flex direction={"column"} gap={3} h={"95%"} w={"100%"}>
        <Flex gap={2} w={"100%"} alignItems="center" p={2}>
          <Heading color={textColor} fontSize="xl">
            Prompts
          </Heading>
          <Button
            colorScheme={buttonColorScheme}
            onClick={() => onOpen()}
            size={"sm"}
          >
            {"Create Prompt"}
          </Button>
        </Flex>

        {status === "loading" ? (
          <Loader />
        ) : (
          <Table
            fetch={getPrompts}
            columns={heads}
            data={tableData}
            table="prompt"
          />
        )}
      </Flex>

      <Flex
        justifyContent={"flex-end"}
        alignItems={"center"}
        marginBlock={2}
        gap={2}
        w={"100%"}
      >
        <PaginationSizeSelect
          paginationSize={paginationSize}
          setPaginationSize={setPaginationSize}
          tableLength={tableData.length}
        />
        <Paginator
          colorScheme={buttonColorScheme}
          onChangePage={setPage}
          page={page}
          pages={pages}
        />
      </Flex>

      {isOpen && (
        <AddPromptModal
          isOpen={isOpen}
          onClose={onClose}
          refreshTable={getPrompts}
        />
      )}
    </VStack>
  );
};

export default Prompt;
